<template>
    <el-dialog
      class="detail-info-dia"
      title="上传课堂笔记"
      :visible.sync="isShow"
      :close-on-click-modal="false"
      :width="dw"
      top="12vh">
        <vue-scroll :ops="vuescrollOpt">
        <el-form :model="note" label-width="90px" class="blackListForm" :rules="formRules" ref="form" style="max-height:625px">
            
            <el-form-item label="文件上传">
                <el-upload
                  ref="uploadFile"
                  action="/api/main/upload_class_note_file.json"
                  :file-list="note.files"
                  :headers="fileUpHeaders"
                  :data="fileUpParam"
                  :before-upload="beforeUpload"
                  :on-progress="isUping"
                  :on-error="uploadError"
                  :on-success="uploadSuccess"
                  :on-remove="fileRemove"
                >
                    <el-button type="primary">点击上传</el-button>
                    <div slot="tip" class>只能上传 pdf/jpg/jpeg/png 文件，且文件大小不能超过200M</div>
                </el-upload>
            </el-form-item>
            <div class="btns">
                <el-button type="primary" @click="sureSubmit" :loading="loading" :disabled="loading">确定</el-button>
                <el-button type="danger" @click="cancel">取消</el-button>
            </div>
        </el-form>
        </vue-scroll>
    </el-dialog>
</template>

<script>
  import {punish_type_list} from "@/assets/js/select";
  import { createNotes, createNotesBefore} from '@/api/classNotes/document';
  import { storageData } from "@/assets/js/storage";
  import createScrollOpt from "@/assets/js/vuescrollOption";
  export default {
    name: "addMaterials",
    data(){
      return{
        punish_type_list,
        loading:false,
        notEdit:false,
        submitDisabled: false,
        vuescrollOpt: createScrollOpt(),
        fileUpHeaders: { "X-Token": storageData.getToken(),"X-UserType":storageData.getUserType() },
        fileUpParam: {},
        note:{
          files: []
        },
        formRules:{
        
        }
      }
    },
    created(){
      this.createBefore();
      if (Object.keys(this.Info).length>0){
        Object.assign(this.note,this.Info)
        this.notEdit=true
      }
    },
    props:{
      showAddDialog:{
        type:Boolean,
        required:true,
        default: false,
      },
      Info:{
        type:Object,
        required :false
      },
      dw:{
        default:'500px',
        required:false,
      }
    },
    computed: {
      isShow: {
        get(){
          return this.showAddDialog;
        },
        set(bool){
          // 参数1：是否显示弹窗
          // 参数2：是否点击确定按钮
          this.$emit("hideTips", bool, false);
        }
      },
    },
    methods:{
      createBefore(){
        createNotesBefore({
        }).then(res=>{
          if (res.data.status===0){
          }else{
          }
        }).catch(error=>{
        })
      },
      beforeUpload(file) {
        if (file.size > 200 * 1024 * 1024) {
          this.$message.error("文件大小不能超过200M!");
          return false;
        }
        if (!/^.*\.(jpg|jpeg|png|pdf)$/i.test(file.name)) {
          this.$message.error("请上传pdf jpg jpeg png  格式的文件!");
          return false;
        }
        let param = {
          document: file
        };
        for (const key in param) {
          if (param.hasOwnProperty(key)) {
            this.$set(this.fileUpParam, key, param[key]);
          }
        }
      },
      isUping() {
        this.submitDisabled = true;
      },
      uploadError() {
        this.submitDisabled = false;
      },
      uploadSuccess(res) {
        this.submitDisabled = false;
        if (Number(res.status) === 0) {
          this.note.files.push({ url: res.result.document_url, name: res.result.document_name })
        } else {
          this.$nextTick(() => { });
          this.$message.error(res.msg);
        }
      },
      fileRemove(file, fileList) {
        this.note.files = fileList;
      },
      cancel(){
        this.isShow=false;
      },
      sureSubmit(){
        this.$refs["form"].validate((valid) => {
          if (valid){
            if(this.note.files.length===0){
              this.$message.error('请至少上传一个文件')
              return
            }
            this.loading=true;
            
            createNotes({
              c_id:this.Info.c_id ,
              stu_id:this.Info.user_id,
              notes_file: JSON.stringify(this.note.files.map(item => ({
                document_url: item.url,
                document_name: item.name,
              })))
            }).then(res=>{
              if (res.data.status===0){
                this.loading=false;
                this.$emit("hideTips", false, true);
              }else{
                this.$message.error(res.data.msg);
                this.loading=false
              }
            }).catch(error=>{
              this.loading=false
            })
          } else{
            this.$message.error('请填写所有带*号的必填项')
          }
        })
        
      }
    },
    components:{
      "image-up": () => import("@/components/UpImage/UpImage"),
    }
  }
</script>

<style scoped lang="stylus">
    .blackListForm
        .btns
            display flex
            justify-content: center
    .el-dialog__body{
        padding-right: 0;
    }
</style>
